import { fetchWrapper } from '../../config/apiClient';
import { GET_TESTIMONIALS, GET_NEWS_UPDATES } from "../../config/endpoints";

export const getAllTestimonials = async (formData) => {
    try {
        const url = `${GET_TESTIMONIALS}`;
        const apiUrl = new URL(url);
        const response = await fetchWrapper(apiUrl, {
            method: "POST",
            body: JSON.stringify(formData),
            headers: {
                "Content-Type": "application/json"
            }
        });
        const result = await response.json();
        return result;
    } catch (error) {
        throw error;
    }
};

export const getAllNews = async (formData = {}) => {
    try {
        const url = `${GET_NEWS_UPDATES}`;
        const apiUrl = new URL(url);
        const response = await fetchWrapper(apiUrl, {
            method: "POST",
            body: JSON.stringify(formData), // Optional filtering
            headers: {
                "Content-Type": "application/json"
            }
        });
        if (!response.ok) {
            // If backend is not ready, return null so we can fall back
            console.warn("News API not reachable, falling back to local data.");
            return null;
        }
        const result = await response.json();
        return result;
    } catch (error) {
        console.warn("News API Fetch Error:", error);
        return null;
    }
};
